"use client";

import React, { useEffect, useState } from "react";
import { useAuthStep } from "@/hooks/useAuthStep";


import { createClient } from "@supabase/supabase-js";

import { z } from "zod";
import { SUPABASE_ANON_KEY, SUPABASE_URL } from "@/lib/config";
import { Loader2 } from "lucide-react";


const supabase = createClient(SUPABASE_URL!, SUPABASE_ANON_KEY!);

const EmailLogin = () => {

    const [email, setEmail] = useState("");

    const [loading, setLoading] = useState(false);
    const { setAuthStep, setEmailLogin } = useAuthStep();



    const handleSignUp = async () => {
        setLoading(true);
        let data, error;

        // Use magic link for both signup and login
        const res = await supabase.auth.signInWithOtp({
            email,
            /*
            options: {
                emailRedirectTo: `${window.location.origin}/auth/callback`
            }
            */
        });
        data = res.data;
        error = res.error;

        if (error) {
            console.error(error);
            setLoading(false);
        } else {
            console.log("Magic link sent to:", email);
            // Show success message instead of immediate redirect
            setAuthStep("emailLoginCode");

        }
    }

    const login = (e: any) => {

        e.preventDefault();
        setEmailLogin(email);
        handleSignUp();
    }

    return (
        <div className="px-[30px] flex flex-col gap-[10px]">
            <h1 className="text-2xl font-semibold mb-[5px]">Log in to BetterCampus</h1>
            <p className="text-gray-500">Over 1.5 million students made their Canvas better.</p>

            <p className="text-black text-base font-medium">Email</p>
            <input
                className="w-full rounded-lg shadow-xs text-gray-500 text-sm p-[10px] border border-gray-200"
                type="email"
                placeholder="lebronjames@gmail.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        login(e);
                    }
                }}
            />
            <button onClick={login} className={`mt-2 w-full rounded-full shadow-xs text-white text-sm p-[10px] border border-gray-200 flex items-center justify-center gap-2 ${email.includes("@") ? "opacity-100" : "opacity-50 pointer-events-none"} `}style={{ "background": "linear-gradient(120deg, var(--brand-1), var(--brand-2))" }}>
                {loading && <span className="text-gray-500 text-sm flex items-center gap-2 mt-2"><Loader2 className="w-4 h-4 animate-spin text-white" /></span>}
                <span>Log in</span>
            </button>

        </div>
    )
}

export default EmailLogin;